module.exports = __webpack_public_path__ + "img/store-zenith-saude.7ddf9933.jpg";